import React, { useEffect } from "react";
import Loader from "../components/common/loader/loader";
import Error from "../components/common/error/error";
import { getEntityStats } from "../api/admin/analytics";
import { getStatsItemsList } from "../constants/analytics-stats";
import usePageTitle from "../hooks/usePageTitle";
import { useNavigate } from "react-router-dom";

function Home() {
  usePageTitle("Home");
  const navigate = useNavigate();
  const [stats, setStats] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  const fetchStats = async () => {
    const response = await getEntityStats();

    if (!response || response.status !== 200) {
      console.log("Error fetching stats");
      setError(true);
      setLoading(false);
      return;
    }

    setStats(getStatsItemsList(response.data));
    setLoading(false);
  };

  // headers change listener
  useEffect(() => {
    fetchStats();
  }, []);

  return (
    <div className="w-full h-full">
      {loading && <Loader pageLoader />}

      {!loading && error && <Error />}

      {!loading && !error && (
        <div className="w-[95%] mx-auto ">
          <div className="w-full mx-auto">
            <h1 className="text-2xl font-bold text-primary">Home</h1>
          </div>

          <div className="w-full flex flex-wrap h-full items-center justify-start mx-auto my-10">
            {stats.map((stat: any) => {
              const Icon = stat.icon;
              return (
                <div
                  key={stat.title}
                  className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4 hover:cursor-pointer"
                  onClick={() => {
                    if (stat.link) {
                      navigate(stat.link);
                    }
                  }}
                >
                  <div className="bg-borderColor shadow-lg rounded-lg p-5">
                    <div className="flex items-center">
                      <Icon className="w-8 h-8 text-primary" />

                      <div className="ml-5">
                        <h2 className="text-sm font-semibold text-white">
                          {stat.title}
                        </h2>

                        <p className="text-lg font-semibold text-white">
                          {stat.count}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
